// Utility to close any open Bootstrap offcanvas components
export function closeOffCanvas() {
  try {
    const offcanvasElements = document.querySelectorAll('.offcanvas.show')
    offcanvasElements.forEach((offcanvasEl) => {
      const closeButton = offcanvasEl.querySelector('[data-bs-dismiss="offcanvas"], .btn-close')
      if (closeButton) {
        // Prefer native dismissal to ensure Bootstrap cleans up classes/backdrop correctly
        closeButton.click()
        return
      }

      // Fallback manual cleanup if no dismiss button is found
      offcanvasEl.classList.remove('show')
      offcanvasEl.setAttribute('aria-hidden', 'true')

      const backdrop = document.querySelector('.offcanvas-backdrop')
      if (backdrop) backdrop.remove()

      document.body.classList.remove('offcanvas-open')
      document.body.style.overflow = ''
    })
  } catch (error) {
    throw error
  }
}
